module.exports = __webpack_public_path__ + "img/T928.92574fd1.jpg";